import { useState, useEffect, useContext } from 'react';
import { StateContext, DispatchContext } from '../../App';

import UnityCanvas from './UnityCanvas/UnityCanvas';
import SideMenu from './SideMenu/SideMenu';
import { useWindowDimensions } from  '../../functions/functions';

import './ConfigManager.css';

const ConfigManager = () => {
    // const dispatch = useContext(DispatchContext);
    const appState = useContext(StateContext);

    const { isSideMenuOpen } = appState.appSettings;
    const [ canvasHeight, setCanvasHeight ] = useState();
    const [ canvasWidth, setCanvasWidth ] = useState();
    
    const { height, width } = useWindowDimensions();
    
    
    useEffect(() => {
        // console.log('adjusting window')
        let canvasHeight = document.getElementById('configManager').clientHeight;
        setCanvasHeight(canvasHeight);
        let windowWidth  = document.getElementById('configManager').clientWidth;
        let menuWidth = document.getElementById('element2').clientWidth;
        let canvasWidth = windowWidth - menuWidth;
        setCanvasWidth(canvasWidth);
    }, [width, isSideMenuOpen]);

    return (
        <div className='configManager' id='configManager'>
            <div className='element1' style={{width: `${canvasWidth}px`, height: `${canvasHeight}px`}}>
                <UnityCanvas canvasHeight={canvasHeight}/>
            </div>
            <div className='element2' id='element2'>
                <SideMenu/>
            </div>
            
            {/* { 
                isSideMenuOpen &&  
            } */}
        </div>
    )
};
export default ConfigManager;